import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/case/view/$id/members")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
